import React from 'react'
import ReactDOM from 'react-dom/client'

// Halton UI Library CSS (imported first for proper cascade order)
import '@haltongroup/halton-ui-library/styles.min.css'
import '@haltongroup/halton-ui-library/theme.min.css'

import App from './App'
import './styles/index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
